export default "__VITE_ASSET__$KYQKB7P__"